import { useValidationBasedControls } from '@shared/lib/form/Form';
import { dateToString } from '@shared/util/date';
import { isMobile } from '@shared/util/userAgents';
import { type ComponentProps } from 'react';
import DesktopDateField from './dateFields/DesktopDateField';
import MobileDateField from './dateFields/MobileDateField';

const currentDate = new Date();
const maxDateObject = {
  oneYear: dateToString(new Date(currentDate.getFullYear() + 1, 11, 31)),
  elevenYears: dateToString(new Date(currentDate.getFullYear() + 11, 11, 31)),
  today: dateToString(currentDate),
};

const maxDateAllowedKeys = Object.keys(maxDateObject) as Array<keyof typeof maxDateObject>;

type Props = ComponentProps<typeof DesktopDateField> | ComponentProps<typeof MobileDateField>;
const DateField = ({ maxDate, ...props }: Props) => {
  const controls = useValidationBasedControls(props.name);

  const DateField = isMobile ? MobileDateField : DesktopDateField;
  // FIXME: For backwards compatibility, we allow string keys [oneYear, elevenYears, today] to be passed as maxDate
  // ideally, we should only set the maxDate property through Yup validation schemas (Yup.max() or Yup.limitFuture())
  const resolvedMaxDate =
    maxDate && maxDateAllowedKeys.includes(maxDate)
      ? maxDateObject[maxDate as keyof typeof maxDateObject]
      : maxDate || controls.maxDate;

  return <DateField {...props} maxDate={resolvedMaxDate} />;
};

export default DateField;
